<template>
  <article class="view-adminorganizationslist">
    <div class="breadcrump-trail">
      <router-link :to="{ name: 'admin-home' }"> Admin </router-link>
      / Organisationen
    </div>

    <h1>{{ $t("words.organization", 2) }}</h1>
    <table class="">
      <tbody>
        <tr>
          <th>{{ $t("labels.name") }}</th>
          <th>{{ $t("words.member", 2) }}</th>
          <th>{{ $t("words.workspace", 2) }}</th>
          <th>{{ $t("labels.owner") }}</th>
          <th>{{ $t("labels.automaticRenewal") }}</th>
          <th>{{ $t("labels.validUntil") }}</th>
        </tr>
        <tr v-for="organization in organizations" :key="organization.id">
          <th>
            <router-link
              :to="{
                name: 'admin-organizations-detail',
                params: { organizationId: organization.id }
              }"
            >
              <strong>{{ organization.name }}</strong>
            </router-link>
          </th>
          <td>
            {{ organization.membersCount }} /
            {{ organization.licenseLimit ?? "∞" }}
          </td>
          <td>
            {{ organization.workspacesCount }} /
            {{ organization.workspaceLimit ?? "∞" }}
          </td>
          <td>
            {{ organization.owner?.name }} ({{ organization.owner?.email }})
          </td>
          <td>
            {{
              organization.subscription.renewAutomatically
                ? $t("labels.active")
                : $t("labels.deactivated")
            }}
            <small v-if="organization.subscription.renewAutomatically">
              ({{ $t(`periods.${organization.subscription.paymentPeriod}`) }})
            </small>
          </td>
          <td>
            <del v-if="isExpired(organization.subscription.validUntil)">
              {{ formatDateString(organization.subscription.validUntil) }}
            </del>
            <template v-else>
              {{ formatDateString(organization.subscription.validUntil) }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </article>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { showError } from "@core/ui/alert/alert";
import { formatDate } from "@/i18n";
import type { AdminOrganization } from "./AdminTypes";
import { useAdmin } from "./useAdmin";

const adminAPI = useAdmin();

const organizations = ref<AdminOrganization[]>([]);

async function reloadOrganizations() {
  try {
    organizations.value = await adminAPI.get<AdminOrganization[]>(
      "/organizations"
    );
  } catch (error) {
    showError(error as Error);
  }
}
reloadOrganizations();

function formatDateString(dateString?: string | null) {
  if (!dateString) return "–";
  const date = new Date(dateString);
  return formatDate(date, "D");
}

function isExpired(dateString?: string | null) {
  if (!dateString) return "–";
  const date = new Date(dateString);
  return date.getTime() < Date.now();
}
</script>

<style lang="scss">
.view-adminorganizationslist {
  width: 100%;
  padding: 2rem;
  table {
    border-collapse: collapse;
    background-color: var(--color-background-deep);
  }
  td,
  th {
    padding: 0.5rem 1rem;
    border: 1px solid var(--color-border-light);
  }
  tr > th {
    text-align: left;
  }
}
</style>
